"use strict";
exports.__esModule = true;
exports.PointFactory = void 0;
exports.PointFactory = {
    createInstance: function (params) {
        var srs = params.srs, x = params.x, y = params.y;
        return { srs: srs, x: x, y: y };
    }
};
//# sourceMappingURL=pointFactory.js.map